import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _omit from 'lodash/omit';
import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { ResponsiveVideo, CustomPropTypes } from '@zillow/zrs-cms';
import StructuredData from '../../components/StructuredData/StructuredData.js';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["loading"];
var BlockVideo = function BlockVideo(_ref) {
  var _ref$attrs = _ref.attrs,
    loading = _ref$attrs.loading,
    attrs = _objectWithoutProperties(_ref$attrs, _excluded),
    index = _ref.index;
  var isPost = usePlacement() === 'post';
  var shouldPreload = loading === 'eager' || attrs.autoPlay;

  // Defaults
  var attributes = Object.assign({
    controls: true,
    preload: shouldPreload ? 'auto' : 'none'
  }, attrs);
  var structuredData = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    thumbnailUrl: [attrs.poster],
    contentUrl: attrs.src
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StructuredData, {
    data: structuredData
  }), /*#__PURE__*/React.createElement(ResponsiveVideo, _extends({
    key: index,
    ratio: attributes.width + '/' + attributes.height
  }, _omit(attributes, 'margin'), isPost ? {
    marginBottom: 'sm'
  } : attributes.margin)), shouldPreload && /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: attrs.poster,
    as: "image"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    href: attrs.src,
    as: "video"
  })));
};
BlockVideo.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    styledWidth: CustomPropTypes.inlineMediaQuery(PropTypes.number)
  }),
  index: PropTypes.number
} : {};
var Video = BlockVideo;

export { Video as default };
